// src/lang/en.js

export const en = {
  hero: {
    subtitle: "ALL-IN-ONE BUSINESS SOLUTION FROM VIETNAM",
    title: "MATRION CONNECTS IMPORT & EXPORT MARKET WITH SIMPLE PROCESS",
    highlight:
      "Delivering value through trust, efficiency, and safe transactions.",
    cta: "Read More",
  },
  nav: {
    home: "HOME",
    about: "ABOUT US",
    products: "PRODUCTS",
    testimonials: "OUR CLIENTS",
    contact: "CONTACT",
  },
  about: {
    subtitle: "About Us",
    title: "MATRION TRADING",
    description:
      "Matrion specialize in providing reliable import and export solutions for businesses related to Vietnamese-made products. With a professional team and network with manufacturers, Matrion will source best products with reasonable price and ensure your transaction to make in-time global delivery.",
    cta: "Read More",

    factsSubtitle1: "WHY CHOOSE MATRION?",
    factsTitle1:
      "#1 Matrion advises A-Z solution for businesses in different industries.",
    factsDescription1:
      "We understand your effort in business and we are here to design and make excellent gifts to your customers.",
    // ________
    factsTitle2: "#2 Matrion ensures high quality standard for all products.",
    factsDescription2:
      "We serve global clients and ensure high quality export standard for all products. ",
    // ________
    factsTitle3: "#3 Matrion provides in-time storage and delivery. ",
    factsDescription3:
      "We provide many options on payment, storage and delivery for your business, save your time instead of dealing with separate manufacturers. ",
    // ________
    factsTitle4: "#4 Matrion gives you competitive cost. ",
    factsDescription4:
      "We have experience in both export (export certificate) and local Vietnam trading, your payment is worth and competitive. ",
    clients: "Happy Clients",
    shipments: "Complete Shipments",
    reviews: "Customer Reviews",
  },

  services: {
    subtitle: "PRODUCTS",
    title: "Explore Our Products Made-In-Vietnam with export quality",
    description:
      "We are importers and distributors of high-quality products for various industries.",
    cta: "Read More",
    items: {
      1: { title: "Motorcycle helmet" },
      2: { title: "Cotton cap" },
      3: { title: "Polo shirt/T-shirt" },
      4: { title: "Moven and non-moven bag" },
      5: { title: "Umbrella" },
      6: { title: "Detergents" },
      7: { title: "Luggage tag" },
      8: { title: "Thermal cup" },
      9: { title: "Pen" },
      10: { title: "Drawstring backpack" },
      11: { title: "Raincoat" },
      12: { title: "Notebook" },
    },
  },
  features: {
    subtitle: "Our Features",
    title: "Our Strategic Customers",
    items: {
      1: "Worldwide Service",
      2: "On Time Delivery",
      3: "24/7 Telephone Support",
    },
  },
  contact: {
    subtitle: "Get a Quote",
    title: "Request a Free Quote!",
    description: "We are here to help you with your freight needs...",
    callLabel: "Call for any query!",
    name: "Name",
    email: "Email",
    phone: "Phone Number",
    message: "Which product you want to get price?",
    freightOption: "Select a Freight",
    send: "Submit",
    sending: "Sending...",
  },
  freight: {
    air: "Air Freight",
    sea: "Sea Freight",
    road: "Road Freight",
  },
  testimonials: {
    subtitle: "OUR STRATEGIC CLIENTS",
    title: "Feedbacks from our strategic clients",
    items: [
      {
        name: "Leslie Alexander",
        company: "FERRARI",
        message:
          "The shipping service was incredibly efficient and fast. Our goods arrived on time with excellent condition!",
      },
      {
        name: "Annette Black",
        company: "LOUIS VUITTON",
        message:
          "We’ve been working with MATRION for years. Their professionalism and logistics solutions are top-notch.",
      },
      {
        name: "Ralph Edwards",
        company: "MITSUBISHI",
        message:
          "Reliable partner for our international supply chain. Highly recommended!",
      },
      {
        name: "Esther Howard",
        company: "TESLA",
        message:
          "Excellent customer service and real-time tracking. MATRION exceeded our expectations!",
      },
      {
        name: "Jenny Wilson",
        company: "AMAZON",
        message:
          "The entire process from pickup to delivery was smooth and seamless. Great job!",
      },
      {
        name: "Devon Lane",
        company: "NIKE",
        message:
          "Thanks to MATRION, we expanded our global reach with confidence and efficiency.",
      },
    ],
  },
  footer: {
    address: {
      title: "Address",
      line1:
        "4/7 XUAN THOI THUONG 6 STREET, XUAN THOI THUONG COMMUNE, HOC MON DISTRICT, HO CHI MINH CITY",
      phone: "(84) 969441533",
      phone2: "(84) 969009553",
      email: "matrionvn@gmail.com",
    },
    products: {
      title: "Products",
      chemicals: "Agriculture Chemicals",
      industrial: "Industrial Chemicals",
      pigments: "Pigments",
      lubricant: "Lubricant",
      detergent: "Detergent",
      tyres: "Tyres",
    },
    links: {
      title: "Quick Links",
      home: "Home",
      about: "About Us",
      careers: "Careers",
      contact: "Contact Us",
    },
    newsletter: {
      title: "Newsletter",
      desc: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur",
      placeholder: "Email",
    },
    copyright:
      "MATRION TRADING AND IMPORT EXPORT COMPANY LIMITED - TAX ID: 0318842287 .",
  },
};
